import { runDemo } from "../shared/demoRunner";
import { createSponzaDynamicShadowsScene } from "./scene";

runDemo({ createScene: createSponzaDynamicShadowsScene });
